import React from 'react';
import { useTranslation } from 'react-i18next';
import { HOME } from '../../../constants/define/translation';
import { IconCreateBlack } from '../../../assets';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
// import { IconCreateBlack, IconPublish } from '../../../assets';

interface HomeExplorerPageHeaderProps {
  onOpenHomeExplorerModal?: () => void;
  extraDropdown?: any;
}

export const HomeExplorerPageHeader = (props: HomeExplorerPageHeaderProps) => {
  const { t } = useTranslation(HOME);
  const { onOpenHomeExplorerModal, extraDropdown } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.buttonCreate'),
      bgWhite: 'true',
      onClick: onOpenHomeExplorerModal,
      icon: <IconCreateBlack />,
    },
    // { key: 2, text: t('header.buttonPublish'), icon: <IconPublish /> },
  ];

  return <ContentPageHeader title={t('header.titleExplorer')} extra={extra} extraDropdown={extraDropdown} />;
};
